module.exports = __webpack_public_path__ + "static/media/bg.00b210f1.png";